import { render, staticRenderFns } from "./login.vue?vue&type=template&id=08015f70&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./login.vue?vue&type=style&index=1&id=08015f70&lang=scss&scoped=true&"
import style2 from "./login.vue?vue&type=style&index=2&id=08015f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08015f70",
  null
  
)

export default component.exports